import React, { useContext, useEffect } from "react";

import { NCRContext } from "views";
import { UserContext } from "components/routing";

import {
  InputLabel
} from 'components/form/prototypes';

const NCRType = () => {

    const { state, setState } = useContext(NCRContext);
    const { user } = useContext(UserContext);

    let returnItems = 0;

    const isUser = 
    ['mg.admin@asafe.com', 'nicki.chaney@asafe.com'].includes(user.id)

    if (state.ncr.return) {
        returnItems = state.ncr.return.returnItems.length
    }
    
    useEffect(() => {
        if (returnItems > 0 && state.ncr.order.orderItems.length === 0) {
            setState(prev => ({...prev,
                ncr: {
                    ...prev.ncr,
                    ncrtype: 1,              
                    }
            })) 
        }
        else if (returnItems === 0 && state.ncr.order.orderItems.length > 0){
            setState(prev => ({...prev,
                ncr: {
                    ...prev.ncr,
                    ncrtype: 2,              
                    }
            })) 
        }
        else if (returnItems > 0 && state.ncr.order.orderItems.length > 0){
            setState(prev => ({...prev,
                ncr: {
                    ...prev.ncr,
                    ncrtype: 3,              
                    }
            })) 
        } else {
            setState(prev => ({...prev,
                ncr: {
                    ...prev.ncr,
                    ncrtype: 4,              
                    }
            })) 
        }
         
      }, [state.ncr.ncrtype, setState, returnItems, state.ncr.order.orderItems.length]);

    

    return (
        <>
        {isUser &&
            <InputLabel
            name='ncr.ncrtype'
            label='NCR Type'
            placeholder={0}                   
            />
        }
        </>
    )
}

export { NCRType };
